import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

export const DeleteIcon = ({ className, onClick, disabled = false }) => (
  <button type="button" onClick={onClick} className="group" title="Delete" disabled={disabled}>
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`stroke-white group-disabled:stroke-gray-400 ${className}`}>
      <path
        d="M15.8334 5.83333L15.1106 15.9521C15.0483 16.8243 14.3226 17.5 13.4482 17.5H6.55191C5.67751 17.5 4.95177 16.8243 4.88947 15.9521L4.16671 5.83333M8.33337 9.16667V14.1667M11.6667 9.16667V14.1667M12.5 5.83333V3.33333C12.5 2.8731 12.1269 2.5 11.6667 2.5H8.33337C7.87314 2.5 7.50004 2.8731 7.50004 3.33333V5.83333M3.33337 5.83333H16.6667"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </button>
);

export const DownloadIcon = ({ className, onClick, disabled = false }) => (
  <button type="button" onClick={onClick} disabled={disabled} className="group" title="Download">
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`stroke-white group-disabled:!stroke-gray-400 ${className}`}>
      <path
        d="M3.33337 13.3334L3.33337 14.1667C3.33337 15.5475 4.45266 16.6667 5.83337 16.6667L14.1667 16.6667C15.5474 16.6667 16.6667 15.5475 16.6667 14.1667L16.6667 13.3334M13.3334 10.0001L10 13.3334M10 13.3334L6.66671 10.0001M10 13.3334L10 3.33342"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  </button>
);

export const ProcessingIcon = ({ pathClass, className }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}>
    <g>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14Z"
        fill="#E6E6E6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.7836 5.42901C11.0858 5.08709 11.0695 4.55006 10.7472 4.22952C10.4248 3.90897 9.9186 3.9263 9.6164 4.26821L6.14921 8.19122L4.3315 6.4773C4.00127 6.16593 3.49561 6.19748 3.20208 6.54777C2.90855 6.89806 2.93829 7.43445 3.26852 7.74581L5.28032 9.6427C5.82041 10.152 6.64463 10.1122 7.13886 9.553L10.7836 5.42901Z"
        fill="#1DD6CE"
        className={pathClass}
      />
    </g>
    <g transform="rotate(45 7 7)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14Z"
        fill="#E6E6E6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.03033 3.96967C4.73744 3.67678 4.26256 3.67678 3.96967 3.96967C3.67678 4.26256 3.67678 4.73744 3.96967 5.03033L5.93934 7L3.96967 8.96967C3.67678 9.26256 3.67678 9.73744 3.96967 10.0303C4.26256 10.3232 4.73744 10.3232 5.03033 10.0303L7 8.06066L8.96967 10.0303C9.26256 10.3232 9.73744 10.3232 10.0303 10.0303C10.3232 9.73744 10.3232 9.26256 10.0303 8.96967L8.06066 7L10.0303 5.03033C10.3232 4.73744 10.3232 4.26256 10.0303 3.96967C9.73744 3.67678 9.26256 3.67678 8.96967 3.96967L7 5.93934L5.03033 3.96967Z"
        fill="#E0531A"
        className={pathClass}
      />
    </g>
  </svg>
);

export const CheckCircledIcon = ({ pathClass, className, fill="#1DD6CE" }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM10.7836 5.42901C11.0858 5.08709 11.0695 4.55006 10.7472 4.22952C10.4248 3.90897 9.9186 3.9263 9.6164 4.26821L6.14921 8.19122L4.3315 6.4773C4.00127 6.16593 3.49561 6.19748 3.20208 6.54777C2.90855 6.89806 2.93829 7.43445 3.26852 7.74581L5.28032 9.6427C5.82041 10.152 6.64463 10.1122 7.13886 9.553L10.7836 5.42901Z"
      fill={fill}
      className={pathClass}
    />
  </svg>
);

export const CrossCircledIcon = ({ pathClass, className }) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14ZM5.03033 3.96967C4.73744 3.67678 4.26256 3.67678 3.96967 3.96967C3.67678 4.26256 3.67678 4.73744 3.96967 5.03033L5.93934 7L3.96967 8.96967C3.67678 9.26256 3.67678 9.73744 3.96967 10.0303C4.26256 10.3232 4.73744 10.3232 5.03033 10.0303L7 8.06066L8.96967 10.0303C9.26256 10.3232 9.73744 10.3232 10.0303 10.0303C10.3232 9.73744 10.3232 9.26256 10.0303 8.96967L8.06066 7L10.0303 5.03033C10.3232 4.73744 10.3232 4.26256 10.0303 3.96967C9.73744 3.67678 9.26256 3.67678 8.96967 3.96967L7 5.93934L5.03033 3.96967Z"
      fill="#E0531A"
      className={pathClass}
    />
  </svg>
);

export const ChevronDownIcon = ({ className }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-[#98A2B3] ${className}`}>
    <path
      d="M14.25 6.75L9 12L3.75 6.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const BookIcon = ({ className }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`stroke-white ${className}`}>
    <path
      d="M14.5 7.79489V22.9616M14.5 7.79489C13.1375 6.88965 11.2876 6.33331 9.25 6.33331C7.21243 6.33331 5.36254 6.88965 4 7.79489V22.9616C5.36254 22.0563 7.21243 21.5 9.25 21.5C11.2876 21.5 13.1375 22.0563 14.5 22.9616M14.5 7.79489C15.8625 6.88965 17.7124 6.33331 19.75 6.33331C21.7876 6.33331 23.6375 6.88965 25 7.79489V22.9616C23.6375 22.0563 21.7876 21.5 19.75 21.5C17.7124 21.5 15.8625 22.0563 14.5 22.9616"
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ScriptIcon = ({ className, ...props }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 28 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`stroke-white ${className}`}
    {...props}>
    <path
      d="M8.16667 5.16669V23.8334M19.8333 5.16669V23.8334M3.5 9.83335H8.16667M19.8333 9.83335H24.5M3.5 14.5H24.5M3.5 19.1667H8.16667M19.8333 19.1667H24.5M4.66667 23.8334H23.3333C23.9777 23.8334 24.5 23.311 24.5 22.6667V6.33335C24.5 5.68902 23.9777 5.16669 23.3333 5.16669H4.66667C4.02233 5.16669 3.5 5.68902 3.5 6.33335V22.6667C3.5 23.311 4.02234 23.8334 4.66667 23.8334Z"
      stroke="currentColor"
      strokeWidth="1.75"
    />
  </svg>
);

export const SeriesIcon = ({ className }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 29 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`stroke-white ${className}`}>
    <path
      d="M19.8335 2.33325L14.0002 8.16659L8.16683 2.33325M4.66683 8.16659H23.3335C24.6222 8.16659 25.6668 9.21125 25.6668 10.4999V23.3333C25.6668 24.6219 24.6222 25.6666 23.3335 25.6666H4.66683C3.37817 25.6666 2.3335 24.6219 2.3335 23.3333V10.4999C2.3335 9.21125 3.37817 8.16659 4.66683 8.16659Z"
      stroke="white"
      strokeWidth="2.33333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ExportIcon = ({ className }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`stroke-white ${className}`}>
    <path
      d="M6.66663 3.99996H3.99996C3.26358 3.99996 2.66663 4.59691 2.66663 5.33329V12C2.66663 12.7363 3.26358 13.3333 3.99996 13.3333H10.6666C11.403 13.3333 12 12.7363 12 12V9.33329M9.33329 2.66663H13.3333M13.3333 2.66663V6.66663M13.3333 2.66663L6.66663 9.33329"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const PlusIcon = ({ className }) => (
  <svg
    width="10"
    height="10"
    viewBox="0 0 10 10"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-white ${className}`}>
    <path d="M5 1V9M9 5L1 5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const CrossBorderedIcon = ({ className }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    stroke="gray"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}>
    <path
      d="M9.16992 14.8299L14.8299 9.16992"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14.8299 14.8299L9.16992 9.16992"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const CheckBorderedIcon = ({ className }) => (
  <svg
    width="24"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}>
    <path
      d="M8.75 12.25L11 14.5L15.25 9.25"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const ProcessingIconDashed = ({ className }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}>
    <path
      d="M11.3269 6.74284L9.71555 6.53265C9.73822 6.35904 9.75 6.1813 9.75 6C9.75 5.8187 9.73822 5.64096 9.71555 5.46735L11.3269 5.25716C11.3587 5.50028 11.375 5.74823 11.375 6C11.375 6.25177 11.3587 6.49972 11.3269 6.74284ZM10.9434 3.8229C10.7516 3.36051 10.5007 2.9289 10.2 2.53754L8.9115 3.52769C9.12665 3.80775 9.30581 4.11597 9.44239 4.44535L10.9434 3.8229ZM9.14997 1.48754L8.15977 2.77603C7.87975 2.56082 7.57153 2.38172 7.24215 2.24513L7.8646 0.74407C8.32699 0.935812 8.75859 1.18679 9.14997 1.48754ZM6.43034 0.360572L6.22015 1.97193C6.04654 1.94927 5.8688 1.9375 5.6875 1.9375C5.5062 1.9375 5.32846 1.94927 5.15485 1.97193L4.94466 0.360572C5.18778 0.328859 5.43573 0.3125 5.6875 0.3125C5.93927 0.3125 6.18722 0.328859 6.43034 0.360572ZM3.5104 0.744071L4.13285 2.24513C3.80347 2.38172 3.49525 2.56082 3.21519 2.77603L2.22504 1.48754C2.6164 1.18679 3.04801 0.935812 3.5104 0.744071ZM1.17504 2.53754L2.46353 3.52769C2.24832 3.80775 2.06922 4.11597 1.93263 4.44535L0.431571 3.8229C0.623312 3.36051 0.874291 2.9289 1.17504 2.53754ZM0.0480723 5.25716C0.0163591 5.50028 0 5.74823 0 6C0 6.25177 0.0163591 6.49972 0.0480724 6.74284L1.65943 6.53265C1.63677 6.35904 1.625 6.1813 1.625 6C1.625 5.8187 1.63677 5.64096 1.65943 5.46735L0.0480723 5.25716ZM0.431571 8.1771L1.93263 7.55465C2.06922 7.88403 2.24832 8.19225 2.46353 8.47227L1.17504 9.46247C0.874291 9.07109 0.623312 8.63949 0.431571 8.1771ZM2.22504 10.5125L3.21519 9.224C3.49525 9.43915 3.80347 9.61831 4.13285 9.75489L3.5104 11.2559C3.04801 11.0641 2.6164 10.8132 2.22504 10.5125ZM4.94466 11.6394L5.15485 10.028C5.32846 10.0507 5.5062 10.0625 5.6875 10.0625C5.8688 10.0625 6.04654 10.0507 6.22015 10.028L6.43034 11.6394C6.18722 11.6712 5.93927 11.6875 5.6875 11.6875C5.43573 11.6875 5.18778 11.6712 4.94466 11.6394ZM7.8646 11.2559L7.24215 9.75489C7.57153 9.61831 7.87975 9.43915 8.15977 9.224L9.14997 10.5125C8.75859 10.8132 8.32699 11.0641 7.8646 11.2559ZM10.2 9.46247L8.9115 8.47227C9.12665 8.19225 9.30581 7.88403 9.44239 7.55465L10.9434 8.1771C10.7516 8.63949 10.5008 9.07109 10.2 9.46247Z"
      fill="#FE6629"
      fillOpacity="0.6"
    />
  </svg>
);

export const ArchiveIcon = ({ className = '' }) => (
  <svg
    width="24"
    height="20"
    viewBox="0 0 24 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-white transition-all duration-300 ${className}`}>
    <path
      d="M19.9033 8.75H3.93532C3.38397 8.75 2.93701 9.09065 2.93701 9.51087V15.9783C2.93701 16.8188 3.83094 17.5 4.93365 17.5H18.9049C20.0077 17.5 20.9016 16.8188 20.9016 15.9783V9.51087C20.9016 9.09065 20.4547 8.75 19.9033 8.75ZM15.1638 11.413C15.1627 11.938 14.6047 12.3633 13.916 12.3641H9.92269C9.2335 12.3641 8.6748 11.9383 8.6748 11.413C8.6748 10.8878 9.2335 10.462 9.92269 10.462H13.916C14.6047 10.4628 15.1627 10.8881 15.1638 11.413Z"
      fill="currentColor"
    />
    <path
      d="M20.5786 2.5H3.26002C2.25319 2.5 1.43701 3.24619 1.43701 4.16666V6.66666C1.43701 7.1269 1.8451 7.5 2.34852 7.5H21.4902C21.9936 7.5 22.4016 7.1269 22.4016 6.66666V4.16666C22.4016 3.24619 21.5854 2.5 20.5786 2.5Z"
      fill="currentColor"
    />
  </svg>
);

export const UnarchiveIcon = ({ className = '', onClick }) => (
  <button type="button" onClick={onClick} className="group" title="Unarchive">
    <svg
      fill="currentColor"
      stroke="currentColor"
      width="20px"
      height="20px"
      viewBox="0 0 36 36"
      version="1.1"
      preserveAspectRatio="xMidYMid meet"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      className={`text-white group-hover:text-primary transition-all duration-300 ${className}`}>
      <path
        d="M29,32H7V22H5V32a2,2,0,0,0,2,2H29a2,2,0,0,0,2-2V22H29Z"
        className="clr-i-outline clr-i-outline-path-1"></path>
      <path
        d="M14,24a1,1,0,0,0,1,1h6a1,1,0,0,0,0-2H15A1,1,0,0,0,14,24Z"
        className="clr-i-outline clr-i-outline-path-2"></path>
      <path
        d="M15,18H6V14h9V12H5.5A1.5,1.5,0,0,0,4,13.5V20H15.78A3,3,0,0,1,15,18Z"
        className="clr-i-outline clr-i-outline-path-3"></path>
      <path
        d="M30.5,12H21v2h9v4H21a3,3,0,0,1-.78,2H32V13.5A1.5,1.5,0,0,0,30.5,12Z"
        className="clr-i-outline clr-i-outline-path-4"></path>
      <path
        d="M13,9.55,17,5.6V18a1,1,0,1,0,2,0V5.6l4,3.95a1,1,0,1,0,1.41-1.42L18,1.78,11.61,8.13A1,1,0,0,0,13,9.55Z"
        className="clr-i-outline clr-i-outline-path-5"></path>
    </svg>
  </button>
);

export const SubmissionLogIcon = ({ className = '' }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-[#D0D5DD] ${className}`}>
    <path
      d="M9.16667 14.1666L10.8333 12.4999L9.16667 10.8333L10.8333 12.4999H5.83333"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.3333 8.33342V12.5001C18.3333 16.6667 16.6667 18.3334 12.5 18.3334H7.5C3.33333 18.3334 1.66667 16.6667 1.66667 12.5001V7.50008C1.66667 3.33341 3.33333 1.66675 7.5 1.66675H11.6667"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.3333 8.33341H15C12.5 8.33341 11.6667 7.50008 11.6667 5.00008V1.66675L18.3333 8.33341Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const PrivacyPolicyIcon = ({ className = '' }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-gray-300 ${className}`}>
    <path
      d="M16.5 7.5V11.25C16.5 15 15 16.5 11.25 16.5H6.75C3 16.5 1.5 15 1.5 11.25V6.75C1.5 3 3 1.5 6.75 1.5H10.5"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.5 7.5H13.5C11.25 7.5 10.5 6.75 10.5 4.5V1.5L16.5 7.5Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.25 9.75H9.75"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.25 12.75H8.25"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const FaqIcon = ({ className = '' }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-gray-300 ${className}`}>
    <path
      d="M12.75 13.8226H9.75L6.41249 16.0425C5.91749 16.3725 5.25 16.0201 5.25 15.4201V13.8226C3 13.8226 1.5 12.3226 1.5 10.0726V5.57251C1.5 3.32251 3 1.82251 5.25 1.82251H12.75C15 1.82251 16.5 3.32251 16.5 5.57251V10.0726C16.5 12.3226 15 13.8226 12.75 13.8226Z"
      stroke="currentColor"
      stroke-width="1.5"
      strokeMiterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9 8.52002V8.36255C9 7.85255 9.31502 7.58254 9.63002 7.36504C9.93752 7.15504 10.245 6.88505 10.245 6.39005C10.245 5.70005 9.69 5.14502 9 5.14502C8.31 5.14502 7.75502 5.70005 7.75502 6.39005"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.99662 10.3125H9.00337"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const ReferalIcon = ({ className = '' }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-gray-300 ${className}`}>
    <path
      d="M9.55 11.4416C10.8433 11.4416 11.8917 10.3932 11.8917 9.09997C11.8917 7.8067 10.8433 6.7583 9.55 6.7583C8.25673 6.7583 7.20833 7.8067 7.20833 9.09997C7.20833 10.3932 8.25673 11.4416 9.55 11.4416Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.875 16.8334C13.875 14.8917 11.9417 13.3083 9.55 13.3083C7.15833 13.3083 5.225 14.8834 5.225 16.8334"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17.5 10.4167C17.5 14.7917 13.9583 18.3333 9.58333 18.3333C5.20833 18.3333 1.66667 14.7917 1.66667 10.4167C1.66667 6.04167 5.20833 2.5 9.58333 2.5C10.675 2.5 11.7167 2.71666 12.6667 3.11666C12.5583 3.44999 12.5 3.8 12.5 4.16667C12.5 4.79167 12.675 5.38333 12.9833 5.88333C13.15 6.16666 13.3667 6.42498 13.6167 6.64164C14.2 7.17498 14.975 7.5 15.8333 7.5C16.2 7.5 16.55 7.44165 16.875 7.32498C17.275 8.27498 17.5 9.325 17.5 10.4167Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.1667 4.16659C19.1667 4.43325 19.1333 4.69158 19.0667 4.94158C18.9917 5.27491 18.8583 5.59992 18.6833 5.88325C18.2833 6.55825 17.6417 7.08323 16.875 7.3249C16.55 7.44157 16.2 7.49992 15.8333 7.49992C14.975 7.49992 14.2 7.17489 13.6167 6.64156C13.3667 6.42489 13.15 6.16658 12.9833 5.88325C12.675 5.38325 12.5 4.79159 12.5 4.16659C12.5 3.79992 12.5583 3.44991 12.6667 3.11658C12.825 2.63324 13.0917 2.19994 13.4417 1.8416C14.05 1.2166 14.9 0.833252 15.8333 0.833252C16.8167 0.833252 17.7083 1.25827 18.3083 1.9416C18.8417 2.53327 19.1667 3.31659 19.1667 4.16659Z"
      stroke="currentColor"
      stroke-width="1.5"
      strokeMiterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17.075 4.1499H14.5917"
      stroke="currentColor"
      stroke-width="1.5"
      strokeMiterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.8333 2.93335V5.42501"
      stroke="currentColor"
      stroke-width="1.5"
      strokeMiterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const AboutUsIcon = ({ className = '' }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-gray-300 ${className}`}>
    <path
      d="M9 16.5C13.125 16.5 16.5 13.125 16.5 9C16.5 4.875 13.125 1.5 9 1.5C4.875 1.5 1.5 4.875 1.5 9C1.5 13.125 4.875 16.5 9 16.5Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9 6V9.75"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.99588 12H9.00262"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const ModifySubscriptionIcon = ({ className = '' }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-gray-300 ${className}`}>
    <path
      d="M16.5 4.875H12"
      stroke="currentColor"
      stroke-width="1.5"
      strokeMiterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.5 4.875H1.5"
      stroke="currentColor"
      stroke-width="1.5"
      strokeMiterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.5 7.5C8.94975 7.5 10.125 6.32475 10.125 4.875C10.125 3.42525 8.94975 2.25 7.5 2.25C6.05025 2.25 4.875 3.42525 4.875 4.875C4.875 6.32475 6.05025 7.5 7.5 7.5Z"
      stroke="currentColor"
      stroke-width="1.5"
      strokeMiterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.5 13.125H13.5"
      stroke="currentColor"
      stroke-width="1.5"
      strokeMiterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6 13.125H1.5"
      stroke="currentColor"
      stroke-width="1.5"
      strokeMiterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.5 15.75C11.9497 15.75 13.125 14.5747 13.125 13.125C13.125 11.6753 11.9497 10.5 10.5 10.5C9.05025 10.5 7.875 11.6753 7.875 13.125C7.875 14.5747 9.05025 15.75 10.5 15.75Z"
      stroke="currentColor"
      stroke-width="1.5"
      strokeMiterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const UpdatePaymentInfoIcon = ({ className = '' }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-gray-300 ${className}`}>
    <path
      d="M1.875 9.92999V8.63251C1.875 7.08001 3.1425 5.8125 4.695 5.8125H13.305C14.8575 5.8125 16.125 7.08001 16.125 8.63251V9.71251H14.61C14.19 9.71251 13.8075 9.87749 13.53 10.1625C13.215 10.47 13.035 10.9125 13.08 11.385C13.1475 12.195 13.89 12.7875 14.7 12.7875H16.125V13.68C16.125 15.2325 14.8575 16.5 13.305 16.5H9.195"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1.875 9.30748V5.88002C1.875 4.98752 2.4225 4.19248 3.255 3.87748L9.21 1.62748C10.14 1.27498 11.1375 1.96501 11.1375 2.96251V5.8125"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.9191 10.4776V12.0227C16.9191 12.4352 16.5891 12.7726 16.1691 12.7876H14.6991C13.8891 12.7876 13.1466 12.1951 13.0791 11.3851C13.0341 10.9126 13.2141 10.4701 13.5291 10.1626C13.8066 9.87763 14.1891 9.71265 14.6091 9.71265H16.1691C16.5891 9.72765 16.9191 10.0651 16.9191 10.4776Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.25 9H10.5"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M2.25 12.375H6.255C6.735 12.375 7.125 12.765 7.125 13.245V14.205"
      stroke="currentColor"
      stroke-width="1.5"
      strokeMiterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3.165 11.46L2.25 12.3749L3.165 13.2899"
      stroke="currentColor"
      stroke-width="1.5"
      strokeMiterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.125 16.3349H3.12C2.64 16.3349 2.25 15.9449 2.25 15.4649V14.5049"
      stroke="currentColor"
      stroke-width="1.5"
      strokeMiterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.21094 17.2502L7.12594 16.3352L6.21094 15.4202"
      stroke="currentColor"
      stroke-width="1.5"
      strokeMiterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const TermsOfUseIcon = ({ className = '' }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-gray-300 ${className}`}>
    <path
      d="M6 1.5V3.75"
      stroke="currentColor"
      stroke-width="1.5"
      strokeMiterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 1.5V3.75"
      stroke="currentColor"
      stroke-width="1.5"
      strokeMiterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.25 8.25H11.25"
      stroke="currentColor"
      stroke-width="1.5"
      strokeMiterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.25 11.25H9"
      stroke="currentColor"
      stroke-width="1.5"
      strokeMiterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.25 16.5H6.75C3 16.5 2.25 14.955 2.25 11.865V7.2375C2.25 3.7125 3.5025 2.7675 6 2.625H12C14.4975 2.76 15.75 3.7125 15.75 7.2375V12"
      stroke="currentColor"
      stroke-width="1.5"
      strokeMiterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15.75 12L11.25 16.5V14.25C11.25 12.75 12 12 13.5 12H15.75Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const CustomTemplateIcon = ({ className = '' }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-gray-300 ${className}`}>
    <path
      d="M6.75 16.5H11.25C15 16.5 16.5 15 16.5 11.25V6.75C16.5 3 15 1.5 11.25 1.5H6.75C3 1.5 1.5 3 1.5 6.75V11.25C1.5 15 3 16.5 6.75 16.5Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9 1.5V16.5"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1.5 7.125H9"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9 10.875H16.5"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const ScriptCoverageIcon = ({ className = ' ' }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-gray-300 ${className}`}>
    <path
      d="M18.05 8.69992L17.2333 12.1833C16.5333 15.1916 15.15 16.4083 12.55 16.1583C12.1333 16.1249 11.6833 16.0499 11.2 15.9333L9.8 15.5999C6.325 14.7749 5.25 13.0583 6.06667 9.57493L6.88333 6.08326C7.05 5.37493 7.25 4.75826 7.5 4.24993C8.475 2.23326 10.1333 1.69159 12.9167 2.34993L14.3083 2.67493C17.8 3.49159 18.8667 5.21659 18.05 8.69992Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.55 16.1583C12.0333 16.5083 11.3833 16.8 10.5917 17.0583L9.275 17.4917C5.96667 18.5583 4.225 17.6667 3.15 14.3583L2.08333 11.0667C1.01667 7.75833 1.9 6.00833 5.20833 4.94167L6.525 4.50833C6.86667 4.4 7.19167 4.30833 7.5 4.25C7.25 4.75833 7.05 5.375 6.88333 6.08333L6.06667 9.575C5.25 13.0583 6.325 14.775 9.8 15.6L11.2 15.9333C11.6833 16.05 12.1333 16.125 12.55 16.1583Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.5333 7.1084L14.575 8.1334"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.71667 10.3333L12.1333 10.9499"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const BookCoverageIcon = ({ className = '' }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-gray-300 ${className}`}>
    <path
      d="M18.3333 13.9501V3.89174C18.3333 2.89174 17.5167 2.15008 16.525 2.23341H16.475C14.725 2.38341 12.0667 3.27508 10.5833 4.20841L10.4417 4.30008C10.2 4.45008 9.8 4.45008 9.55833 4.30008L9.35 4.17508C7.86667 3.25008 5.21667 2.36674 3.46667 2.22508C2.475 2.14174 1.66667 2.89174 1.66667 3.88341V13.9501C1.66667 14.7501 2.31667 15.5001 3.11667 15.6001L3.35833 15.6334C5.16667 15.8751 7.95833 16.7917 9.55833 17.6667L9.59167 17.6834C9.81667 17.8084 10.175 17.8084 10.3917 17.6834C11.9917 16.8001 14.7917 15.8751 16.6083 15.6334L16.8833 15.6001C17.6833 15.5001 18.3333 14.7501 18.3333 13.9501Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10 4.57495V17.075"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.45833 7.07495H4.58333"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.08333 9.57495H4.58333"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const DraftComparisonIcon = ({ className = '' }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.5 6V10H16M14.6847 2L10 2C8.89543 2 8 2.89543 8 4V16C8 17.1046 8.89543 18 10 18L18 18C19.1046 18 20 17.1046 20 16V7.24162C20 6.7034 19.7831 6.18789 19.3982 5.81161L16.0829 2.56999C15.7092 2.2046 15.2074 2 14.6847 2Z"
      stroke="currentColor"
      stroke-width="1"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16 18V20C16 21.1046 15.1046 22 14 22H6C4.89543 22 4 21.1046 4 20V9C4 7.89543 4.89543 7 6 7H8"
      stroke="currentColor"
      stroke-width="1"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const BillingIcon = ({ className = '' }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-gray-300 ${className}`}>
    <path
      d="M5.60833 16.4167C6.29167 15.6834 7.33333 15.7417 7.93333 16.5417L8.775 17.6667C9.45 18.5584 10.5417 18.5584 11.2167 17.6667L12.0583 16.5417C12.6583 15.7417 13.7 15.6834 14.3833 16.4167C15.8667 18.0001 17.075 17.4751 17.075 15.2584V5.86675C17.0833 2.50841 16.3 1.66675 13.15 1.66675H6.85C3.7 1.66675 2.91667 2.50841 2.91667 5.86675V15.2501C2.91667 17.4751 4.13333 17.9917 5.60833 16.4167Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.66667 5.83325H13.3333"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.5 9.16675H12.5"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const PoliciesIcon = ({ className = '' }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-gray-300 ${className}`}>
    <path
      d="M17.5 5.83341V14.1667C17.5 16.6667 16.25 18.3334 13.3333 18.3334H6.66667C3.75 18.3334 2.5 16.6667 2.5 14.1667V5.83341C2.5 3.33341 3.75 1.66675 6.66667 1.66675H13.3333C16.25 1.66675 17.5 3.33341 17.5 5.83341Z"
      stroke="currentColor"
      stroke-width="1.5"
      strokeMiterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12.0833 3.75V5.41667C12.0833 6.33333 12.8333 7.08333 13.75 7.08333H15.4167"
      stroke="currentColor"
      stroke-width="1.5"
      strokeMiterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.66667 10.8333H10"
      stroke="currentColor"
      stroke-width="1.5"
      strokeMiterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.66667 14.1667H13.3333"
      stroke="currentColor"
      stroke-width="1.5"
      strokeMiterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const SettingsIcon = ({ className = '' }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-gray-300 ${className}`}>
    <path
      d="M10 12.5C11.3807 12.5 12.5 11.3807 12.5 10C12.5 8.61929 11.3807 7.5 10 7.5C8.61929 7.5 7.5 8.61929 7.5 10C7.5 11.3807 8.61929 12.5 10 12.5Z"
      stroke="currentColor"
      stroke-width="1.5"
      strokeMiterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M1.66667 10.7334V9.2667C1.66667 8.40003 2.375 7.68336 3.25 7.68336C4.75833 7.68336 5.375 6.6167 4.61667 5.30836C4.18333 4.55836 4.44167 3.58336 5.2 3.15003L6.64167 2.32503C7.3 1.93336 8.15 2.1667 8.54167 2.82503L8.63333 2.98336C9.38333 4.2917 10.6167 4.2917 11.375 2.98336L11.4667 2.82503C11.8583 2.1667 12.7083 1.93336 13.3667 2.32503L14.8083 3.15003C15.5667 3.58336 15.825 4.55836 15.3917 5.30836C14.6333 6.6167 15.25 7.68336 16.7583 7.68336C17.625 7.68336 18.3417 8.3917 18.3417 9.2667V10.7334C18.3417 11.6 17.6333 12.3167 16.7583 12.3167C15.25 12.3167 14.6333 13.3834 15.3917 14.6917C15.825 15.45 15.5667 16.4167 14.8083 16.85L13.3667 17.675C12.7083 18.0667 11.8583 17.8334 11.4667 17.175L11.375 17.0167C10.625 15.7084 9.39167 15.7084 8.63333 17.0167L8.54167 17.175C8.15 17.8334 7.3 18.0667 6.64167 17.675L5.2 16.85C4.44167 16.4167 4.18333 15.4417 4.61667 14.6917C5.375 13.3834 4.75833 12.3167 3.25 12.3167C2.375 12.3167 1.66667 11.6 1.66667 10.7334Z"
      stroke="currentColor"
      stroke-width="1.5"
      strokeMiterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const LogoutIcon = ({ className = '' }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-white ${className}`}>
    <path
      d="M8.90002 7.55999C9.21002 3.95999 11.06 2.48999 15.11 2.48999H15.24C19.71 2.48999 21.5 4.27999 21.5 8.74999V15.27C21.5 19.74 19.71 21.53 15.24 21.53H15.11C11.09 21.53 9.24002 20.08 8.91002 16.54"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15 12H3.62"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M5.85 8.6499L2.5 11.9999L5.85 15.3499"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const GreenBorderedCheckIcon = (className = '') => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-[green] ${className}`}>
    <path
      d="M8.75 12.25L11 14.5L15.25 9.25"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const NoteIcon = ({ className = '' }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-white ${className}`}>
    <path
      d="M16.245 7.83001L15.51 10.965C14.88 13.6725 13.635 14.7675 11.295 14.5425C10.92 14.5125 10.515 14.445 10.08 14.34L8.82001 14.04C5.69251 13.2975 4.72501 11.7525 5.46001 8.61751L6.19501 5.47501C6.34501 4.83751 6.52501 4.28251 6.75001 3.82501C7.62751 2.01001 9.12001 1.52251 11.625 2.11501L12.8775 2.40751C16.02 3.14251 16.98 4.69501 16.245 7.83001Z"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.295 14.5425C10.83 14.8575 10.245 15.12 9.53251 15.3525L8.34751 15.7425C5.37001 16.7025 3.80251 15.9 2.83501 12.9225L1.87501 9.96001C0.915012 6.98251 1.71001 5.40751 4.68751 4.44751L5.87251 4.05751C6.18001 3.96001 6.47251 3.87751 6.75001 3.82501C6.52501 4.28251 6.34501 4.83751 6.19501 5.47501L5.46001 8.61751C4.72501 11.7525 5.69251 13.2975 8.82001 14.04L10.08 14.34C10.515 14.445 10.92 14.5125 11.295 14.5425Z"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.47998 6.39749L13.1175 7.31999"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M8.745 9.29999L10.92 9.85499"
      stroke="currentColor"
      stroke-width="1.2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const InfoIcon = forwardRef(({ className = '', ...props }, ref) => (
  <svg
    ref={ref}
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    className={twMerge('text-white', className)}>
    <g clip-path="url(#clip0_9834_7868)">
      <path
        d="M10.0001 18.3334C14.6025 18.3334 18.3334 14.6024 18.3334 10C18.3334 5.39765 14.6025 1.66669 10.0001 1.66669C5.39771 1.66669 1.66675 5.39765 1.66675 10C1.66675 14.6024 5.39771 18.3334 10.0001 18.3334Z"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 13.3333V10"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 6.66669H10.0083"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_9834_7868">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
));

export const ChevronLeftIcon = ({ className = '' }) => (
  <svg
    width="7"
    height="15"
    viewBox="0 0 7 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-[#BEBEBE] ${className}`}>
    <path
      d="M5.96059 0.937684L1.67276 6.41641C1.16637 7.06343 1.16637 8.12221 1.67276 8.76923L5.96059 14.248"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeMiterlimit="10"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const LeftArrowIcon = ({ className = '' }) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-white ${className}`}>
    <path
      d="M10.5 15.8333L4.66663 10L10.5 4.16666"
      stroke="currentColor"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M16.3333 10H4.66663"
      stroke="currentColor"
      stroke-width="1.25"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const RightChevronIcon = ({ className = '' }) => (
  <svg
    width="7"
    height="16"
    viewBox="0 0 7 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-[#BEBEBE] ${className}`}>
    <path
      d="M1.0001 14.3103L5.28794 8.83155C5.79432 8.18452 5.79432 7.12575 5.28794 6.47872L1.0001 1"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const DispalyPropertiesIcon = ({ className = '' }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-[#EEEFFC] ${className}`}>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.5 10.5C9.63261 10.5 9.75979 10.5527 9.85355 10.6464C9.94732 10.7402 10 10.8674 10 11V14C10 14.1326 9.94732 14.2598 9.85355 14.3536C9.75979 14.4473 9.63261 14.5 9.5 14.5H8.5C8.36739 14.5 8.24021 14.4473 8.14645 14.3536C8.05268 14.2598 8 14.1326 8 14V11C8 10.8674 8.05268 10.7402 8.14645 10.6464C8.24021 10.5527 8.36739 10.5 8.5 10.5H9.5ZM7 11.5V13H1.75C1.55109 13 1.36032 12.921 1.21967 12.7803C1.07902 12.6397 1 12.4489 1 12.25C1 12.0511 1.07902 11.8603 1.21967 11.7197C1.36032 11.579 1.55109 11.5 1.75 11.5H7ZM14.25 11.5C14.4489 11.5 14.6397 11.579 14.7803 11.7197C14.921 11.8603 15 12.0511 15 12.25C15 12.4489 14.921 12.6397 14.7803 12.7803C14.6397 12.921 14.4489 13 14.25 13H11V11.5H14.25ZM5.5 6C5.63261 6 5.75979 6.05268 5.85355 6.14645C5.94732 6.24021 6 6.36739 6 6.5V9.5C6 9.63261 5.94732 9.75979 5.85355 9.85355C5.75979 9.94732 5.63261 10 5.5 10H4.5C4.36739 10 4.24021 9.94732 4.14645 9.85355C4.05268 9.75979 4 9.63261 4 9.5V6.5C4 6.36739 4.05268 6.24021 4.14645 6.14645C4.24021 6.05268 4.36739 6 4.5 6H5.5ZM3 7.25V8.75H1.75C1.55109 8.75 1.36032 8.67098 1.21967 8.53033C1.07902 8.38968 1 8.19891 1 8C1 7.80109 1.07902 7.61032 1.21967 7.46967C1.36032 7.32902 1.55109 7.25 1.75 7.25H3ZM14.25 7.25C14.4489 7.25 14.6397 7.32902 14.7803 7.46967C14.921 7.61032 15 7.80109 15 8C15 8.19891 14.921 8.38968 14.7803 8.53033C14.6397 8.67098 14.4489 8.75 14.25 8.75H7V7.25H14.25ZM11.5 1.75C11.6326 1.75 11.7598 1.80268 11.8536 1.89645C11.9473 1.99021 12 2.11739 12 2.25V5.25C12 5.38261 11.9473 5.50979 11.8536 5.60355C11.7598 5.69732 11.6326 5.75 11.5 5.75H10.5C10.3674 5.75 10.2402 5.69732 10.1464 5.60355C10.0527 5.50979 10 5.38261 10 5.25V2.25C10 2.11739 10.0527 1.99021 10.1464 1.89645C10.2402 1.80268 10.3674 1.75 10.5 1.75H11.5ZM9 3V4.5H1.75C1.55109 4.5 1.36032 4.42098 1.21967 4.28033C1.07902 4.13968 1 3.94891 1 3.75C1 3.55109 1.07902 3.36032 1.21967 3.21967C1.36032 3.07902 1.55109 3 1.75 3H9ZM14.25 3C14.4489 3 14.6397 3.07902 14.7803 3.21967C14.921 3.36032 15 3.55109 15 3.75C15 3.94891 14.921 4.13968 14.7803 4.28033C14.6397 4.42098 14.4489 4.5 14.25 4.5H13V3H14.25Z"
      fill="currentColor"
    />
  </svg>
);

export const SparklesIcon = ({ className, ...props }) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    className={twMerge('text-white', className)}>
    <path
      d="M3.75 2.25V5.25M2.25 3.75H5.25M4.5 12.75V15.75M3 14.25H6M9.75 2.25L11.4643 7.39286L15.75 9L11.4643 10.6071L9.75 15.75L8.03571 10.6071L3.75 9L8.03571 7.39286L9.75 2.25Z"
      stroke={'currentColor'}
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const ListIcon = ({ className, ...props }) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      className={twMerge('text-white', className)}>
      <path
        d="M1.66667 17.5C1.6666 16.217 2.03678 14.9611 2.73279 13.8832C3.4288 12.8054 4.42106 11.9512 5.5905 11.4234C6.75994 10.8955 8.05686 10.7163 9.32563 10.9072C10.5944 11.0982 11.7811 11.6513 12.7433 12.5"
        stroke={'currentColor'}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.33333 10.8333C10.6345 10.8333 12.5 8.96785 12.5 6.66667C12.5 4.36548 10.6345 2.5 8.33333 2.5C6.03215 2.5 4.16667 4.36548 4.16667 6.66667C4.16667 8.96785 6.03215 10.8333 8.33333 10.8333Z"
        stroke={'currentColor'}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.8333 13.3333V18.3333"
        stroke={'currentColor'}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.3333 15.8333H13.3333"
        stroke={'currentColor'}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const MovieIcon = () => {
  return (
    <svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.70833 1.875H2.29167C1.78541 1.875 1.375 2.28541 1.375 2.79167V9.20833C1.375 9.71459 1.78541 10.125 2.29167 10.125H8.70833C9.21459 10.125 9.625 9.71459 9.625 9.20833V2.79167C9.625 2.28541 9.21459 1.875 8.70833 1.875Z"
        stroke="white"
        stroke-width="0.6875"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.20831 1.875V10.125"
        stroke="white"
        stroke-width="0.6875"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.375 3.9375H3.20833"
        stroke="white"
        stroke-width="0.6875"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.375 6H9.625"
        stroke="white"
        stroke-width="0.6875"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M1.375 8.0625H3.20833"
        stroke="white"
        stroke-width="0.6875"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.79169 1.875V10.125"
        stroke="white"
        stroke-width="0.6875"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.79169 3.9375H9.62502"
        stroke="white"
        stroke-width="0.6875"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.79169 8.0625H9.62502"
        stroke="white"
        stroke-width="0.6875"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const Cross = ({ ...props }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    className={`${props?.className} text-white`}>
    <path
      d="M4 12L12 4M4 4L12 12"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const Cast = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <rect width="16" height="16" fill="url(#pattern0_12171_26299)" />
    <defs>
      <pattern
        id="pattern0_12171_26299"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1">
        <use xlinkHref="#image0_12171_26299" transform="scale(0.02)" />
      </pattern>
      <image
        id="image0_12171_26299"
        width="50"
        height="50"
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAABs0lEQVR4nO2Zu0oDQRRABwOCWvmo0gjBtMZGLLRXJKAo0cbPED/AStFv8AGiKApRgn9gJ9ZBorXYWCQRgyRHhlzBQhKzO8kdcA4MLLszu/ewszN3dowJBAKBKAD9wDpwChSBipSinFuzdYzPAKvAE+0pASvGN4AEsE/n7AF9xheIJvHNrvGoO8Vl2YcPuxRbA55VBwCao5MrcpoiZw5FTjRFHh2KFDVFyg5FypoiTjGKIg2HHg1NkVeHIi+aIg8ORe41RWyu5IodTZEZhyLTaiIiU3AgkVeVsABp4C2GhG07YXwAWABqESQ+gHnjE8CcHUI7kLB1Z42PACOyyKq2EKjKaDdsfAcYtIslYBs4BA7keMle044vEAj8d4CknRQjTqTJ7kTVWfCbwB1QlzniGkj9oW0KuJE2dbmHvVfvpIBJ4KhFSvIJnAMbkocNSUnLuQup8xs14BjIdFNg3Gap9I68fabrH9RbsjXQayrS5RIuUo1b9CkAA3FErvCHy6gSU/hHJopIFv9YjCIy1mZdofHhj3Ys8mPb4F3bgGYM8bYd5M3YbpZTKlkbQyyJQCAQML7xBRtHNcS0njIqAAAAAElFTkSuQmCC"
      />
    </defs>
  </svg>
);

export const Writer = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8 13.3333H14"
      stroke="white"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.9173 2.41473C11.1827 2.14934 11.5427 2.00024 11.918 2.00024C12.2933 2.00024 12.6533 2.14934 12.9187 2.41473C13.1841 2.68013 13.3332 3.04008 13.3332 3.4154C13.3332 3.79072 13.1841 4.15067 12.9187 4.41607L4.912 12.4234C4.7534 12.582 4.55735 12.698 4.342 12.7607L2.42734 13.3194C2.36997 13.3361 2.30916 13.3371 2.25128 13.3223C2.19339 13.3075 2.14056 13.2774 2.0983 13.2351C2.05605 13.1928 2.02593 13.14 2.0111 13.0821C1.99627 13.0242 1.99727 12.9634 2.014 12.9061L2.57267 10.9914C2.63549 10.7763 2.7515 10.5805 2.91 10.4221L10.9173 2.41473Z"
      stroke="white"
      stroke-width="1.3"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const Director = () => (
  <svg
    width="13"
    height="14"
    viewBox="0 0 13 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink">
    <rect y="0.5" width="13" height="13" fill="url(#pattern0_12171_26297)" />
    <defs>
      <pattern
        id="pattern0_12171_26297"
        patternContentUnits="objectBoundingBox"
        width="1"
        height="1">
        <use xlinkHref="#image0_12171_26297" transform="scale(0.02)" />
      </pattern>
      <image
        id="image0_12171_26297"
        width="50"
        height="50"
        xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAADK0lEQVR4nO3ZbYhUVRgH8Ju6mkuk+RrTiyhCKhiiJGikIEZEQaXpFxMKKYgEQRIDP0QEoWLgtwoUgoRSIoKgF6igwkjwgwYWiEKUldiLoaJG5i+Oe4Y9DDPrrHvP7G7ePxwG7j3z/J//3DPP2y2KChUqlAZswGvozsgxCjuxJSfBJT14OAtJcYVnkV5MykEwOiH4AC9gLZZhNm66BpvduAtL8QQ2YW/CU8stpBUu4E/8jOP4FgfjOhyv/RT3nG/DXm2whJSNWm4hr+NG7BruQlbEa6srIe2hVj2RVqiO1sBQK8pG9USGyRN5/P8i5A58N0BnL+IH7Md7eL/jQpJ7IzAZs3Avlse1Eqviuj9eW4D5mNGsusWSQRNSMs+S3EJuwAlcDr9o6QSdEhKAKZhTZIScQjAurFKNtidkJiaWZXhu0gQdj5HlRTyK6aWQ9PBMjd3mjkTIv/gbi8sgmBNDZCucxtd4B6/GAcWTISAk0au+gvinsBHbsQ8H8PtVQvQjZf1aC/G9zuN06OVLEZGIGRvHNCFq1RH68PV4GW/hKxzDbzjXR08fjug3cdCwDc/ho4a9YcBxa6kiGgQti5m4jvCkFvax/2bc0sf9UB18mtg7g3XZBDRx7o2E/B9sDUmzn3ZCxv8jsbM/RKp8nrd25ME4+qkjjH/mtfG98djTcOQ2Y2RnPG/uVKix3m1w6vlQf7XY/xBOJvsP5k6y/UKcFIYoU8eXoTBsUhlcSo7jS+gqhhpwOz5p+OM+Heq0eL8Ln8WIdU8xlKGnuHwGZxNBH+O2YjgC0/FFIiYcu7XFcAJGxc+RcWqfljhvY0IxlIHFsfX9Nc3KuBuHEjG/hNBdDDVgTEyI9YgUPmc36TBfSfZcjkm13+9VsiAkwJgI6whd5ANXeSN1NNkf6q77isGCnldxm2O/UMe+dhqhWIBujf1G+nS6O+N9ryMzYsJLI9Kaa7ATepQfEztHwpQlj9fNc0Raon84kN46ttHNCtCucr3vJZyIzxPCv0InWKL9x3AqsX8g1zjo2YQklBl3ZuCY0jBpLP9deyTZHY/WldopF7AGb2JaTp4KFa4n/AfY1unP6wNG1QAAAABJRU5ErkJggg=="
      />
    </defs>
  </svg>
);

export const Upload = ({ ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    fill="currentColor"
    viewBox="0 0 256 256"
    {...props}>
    <path d="M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,16V152h-28.7A15.86,15.86,0,0,0,168,156.69L148.69,176H107.31L88,156.69A15.86,15.86,0,0,0,76.69,152H48V48Zm0,160H48V168H76.69L96,187.31A15.86,15.86,0,0,0,107.31,192h41.38A15.86,15.86,0,0,0,160,187.31L179.31,168H208v40ZM90.34,109.66a8,8,0,0,1,0-11.32l32-32a8,8,0,0,1,11.32,0l32,32a8,8,0,0,1-11.32,11.32L136,91.31V152a8,8,0,0,1-16,0V91.31l-18.34,18.35A8,8,0,0,1,90.34,109.66Z"></path>
  </svg>
);

export const TitleIcon = ({ className = '' }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-[#DCD8FE] ${className}`}>
    <path
      d="M14.9408 8.91426L12.9576 8.65557C12.9855 8.4419 13 8.22314 13 8C13 7.77686 12.9855 7.5581 12.9576 7.34443L14.9408 7.08573C14.9799 7.38496 15 7.69013 15 8C15 8.30987 14.9799 8.61504 14.9408 8.91426ZM14.4688 5.32049C14.2328 4.7514 13.9239 4.22019 13.5538 3.73851L11.968 4.95716C12.2328 5.30185 12.4533 5.68119 12.6214 6.08659L14.4688 5.32049ZM12.2615 2.4462L11.0428 4.03204C10.6981 3.76716 10.3188 3.54673 9.91341 3.37862L10.6795 1.53116C11.2486 1.76715 11.7798 2.07605 12.2615 2.4462ZM8.91426 1.05917L8.65557 3.04237C8.4419 3.01449 8.22314 3 8 3C7.77686 3 7.5581 3.01449 7.34443 3.04237L7.08574 1.05917C7.38496 1.02013 7.69013 1 8 1C8.30987 1 8.61504 1.02013 8.91426 1.05917ZM5.32049 1.53116L6.08659 3.37862C5.68119 3.54673 5.30185 3.76716 4.95716 4.03204L3.73851 2.4462C4.22019 2.07605 4.7514 1.76715 5.32049 1.53116ZM2.4462 3.73851L4.03204 4.95716C3.76716 5.30185 3.54673 5.68119 3.37862 6.08659L1.53116 5.32049C1.76715 4.7514 2.07605 4.22019 2.4462 3.73851ZM1.05917 7.08574C1.02013 7.38496 1 7.69013 1 8C1 8.30987 1.02013 8.61504 1.05917 8.91426L3.04237 8.65557C3.01449 8.4419 3 8.22314 3 8C3 7.77686 3.01449 7.5581 3.04237 7.34443L1.05917 7.08574ZM1.53116 10.6795L3.37862 9.91341C3.54673 10.3188 3.76716 10.6981 4.03204 11.0428L2.4462 12.2615C2.07605 11.7798 1.76715 11.2486 1.53116 10.6795ZM3.73851 13.5538L4.95716 11.968C5.30185 12.2328 5.68119 12.4533 6.08659 12.6214L5.32049 14.4688C4.7514 14.2328 4.22019 13.9239 3.73851 13.5538ZM7.08574 14.9408L7.34443 12.9576C7.5581 12.9855 7.77686 13 8 13C8.22314 13 8.4419 12.9855 8.65557 12.9576L8.91427 14.9408C8.61504 14.9799 8.30987 15 8 15C7.69013 15 7.38496 14.9799 7.08574 14.9408ZM10.6795 14.4688L9.91341 12.6214C10.3188 12.4533 10.6981 12.2328 11.0428 11.968L12.2615 13.5538C11.7798 13.9239 11.2486 14.2328 10.6795 14.4688ZM13.5538 12.2615L11.968 11.0428C12.2328 10.6981 12.4533 10.3188 12.6214 9.91341L14.4688 10.6795C14.2328 11.2486 13.924 11.7798 13.5538 12.2615Z"
      fill="currentColor"
      fillOpacity="0.565"
    />
  </svg>
);

export const WriterIcon = ({ className = '' }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-[#DCD8FE] ${className}`}>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8 15C9.85652 15 11.637 14.2625 12.9497 12.9497C14.2625 11.637 15 9.85652 15 8C15 6.14348 14.2625 4.36301 12.9497 3.05025C11.637 1.7375 9.85652 1 8 1C6.14348 1 4.36301 1.7375 3.05025 3.05025C1.7375 4.36301 1 6.14348 1 8C1 9.85652 1.7375 11.637 3.05025 12.9497C4.36301 14.2625 6.14348 15 8 15ZM5.121 10.879L4.111 11.889C3.34179 11.1198 2.81794 10.1398 2.6057 9.07291C2.39346 8.00601 2.50236 6.90013 2.91864 5.89512C3.33491 4.89012 4.03986 4.03112 4.94434 3.42676C5.84881 2.8224 6.91219 2.49983 8 2.49983C9.08781 2.49983 10.1512 2.8224 11.0557 3.42676C11.9601 4.03112 12.6651 4.89012 13.0814 5.89512C13.4976 6.90013 13.6065 8.00601 13.3943 9.07291C13.1821 10.1398 12.6582 11.1198 11.889 11.889L10.879 10.879C10.6004 10.6003 10.2696 10.3792 9.90545 10.2284C9.54135 10.0776 9.1511 9.99995 8.757 10H7.243C6.8489 9.99995 6.45865 10.0776 6.09455 10.2284C5.73045 10.3792 5.39963 10.6003 5.121 10.879Z"
      fill="currentColor"
      fillOpacity="0.565"
    />
    <path
      d="M8 4C7.46957 4 6.96086 4.21071 6.58579 4.58579C6.21071 4.96086 6 5.46957 6 6V6.5C6 7.03043 6.21071 7.53914 6.58579 7.91421C6.96086 8.28929 7.46957 8.5 8 8.5C8.53043 8.5 9.03914 8.28929 9.41421 7.91421C9.78929 7.53914 10 7.03043 10 6.5V6C10 5.46957 9.78929 4.96086 9.41421 4.58579C9.03914 4.21071 8.53043 4 8 4Z"
      fill="currentColor"
      fillOpacity="0.565"
    />
  </svg>
);

export const DirectorIcon = ({ className = '' }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-[#DCD8FE] ${className}`}>
    <path
      d="M5.88517 13.967C5.60717 14.292 5.15017 14.41 4.77217 14.213C3.76363 13.6882 2.89809 12.9256 2.25039 11.9912C1.6027 11.0568 1.19235 9.97875 1.05482 8.85018C0.917294 7.7216 1.05673 6.57651 1.46106 5.51392C1.8654 4.45133 2.52248 3.50321 3.37547 2.75155C4.22847 1.99989 5.25171 1.46731 6.35673 1.19986C7.46175 0.932408 8.61528 0.938135 9.71759 1.21655C10.8199 1.49496 11.8378 2.03767 12.6833 2.79777C13.5288 3.55786 14.1764 4.51245 14.5702 5.57901C14.7402 6.04201 14.3722 6.50001 13.8782 6.50001C13.5322 6.50001 13.2332 6.26801 13.1042 5.94601C12.6263 4.76212 11.7515 3.78127 10.6298 3.17153C9.50813 2.5618 8.20929 2.36113 6.95588 2.60392C5.70246 2.84671 4.5725 3.51783 3.75959 4.5023C2.94669 5.48677 2.50145 6.7233 2.50017 8.00001C2.50017 9.51901 3.11617 10.894 4.11017 11.89L5.12117 10.879C5.3998 10.6003 5.73062 10.3792 6.09472 10.2284C6.45882 10.0776 6.84907 9.99996 7.24317 10H8.75717C8.97517 10 9.07017 10.252 8.92817 10.417L5.88517 13.967Z"
      fill="currentColor"
      fillOpacity="0.565"
    />
    <path
      d="M6.00024 6.00002C6.00024 5.46958 6.21096 4.96087 6.58603 4.5858C6.9611 4.21073 7.46981 4.00002 8.00024 4.00002C8.53068 4.00002 9.03938 4.21073 9.41446 4.5858C9.78953 4.96087 10.0002 5.46958 10.0002 6.00002V6.50002C10.0002 7.03045 9.78953 7.53916 9.41446 7.91423C9.03938 8.2893 8.53068 8.50002 8.00024 8.50002C7.46981 8.50002 6.9611 8.2893 6.58603 7.91423C6.21096 7.53916 6.00024 7.03045 6.00024 6.50002V6.00002ZM13.2632 8.13801L9.37824 12.048C9.75628 12.1617 10.1034 12.3601 10.3931 12.6282C10.6829 12.8963 10.9076 13.2269 11.0502 13.595L14.8762 9.74802C15.1692 9.48202 14.8842 8.64102 14.6182 8.37802C14.3392 8.10302 13.5152 7.82601 13.2632 8.13801ZM10.2502 14.364C10.2097 13.9692 10.0257 13.6029 9.73328 13.3346C9.44081 13.0663 9.0601 12.9145 8.66324 12.908C8.41624 13.399 8.16324 14.157 8.01324 14.638C7.99794 14.6849 7.99545 14.7351 8.00603 14.7833C8.01661 14.8315 8.03988 14.876 8.07342 14.9122C8.10697 14.9484 8.14958 14.975 8.19684 14.9892C8.2441 15.0034 8.2943 15.0047 8.34224 14.993C8.90224 14.866 9.82224 14.63 10.2512 14.363L10.2502 14.364Z"
      fill="currentColor"
      fillOpacity="0.565"
    />
  </svg>
);

export const ProducersIcon = ({ className = '' }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-[#DCD8FE] ${className}`}>
    <path
      d="M8 5H7C6.44772 5 6 5.44772 6 6V13C6 13.5523 6.44772 14 7 14H8C8.55228 14 9 13.5523 9 13V6C9 5.44772 8.55228 5 8 5Z"
      fill="currentColor"
      fillOpacity="0.565"
    />
    <path
      d="M3 8H2C1.44772 8 1 8.44772 1 9V13C1 13.5523 1.44772 14 2 14H3C3.55228 14 4 13.5523 4 13V9C4 8.44772 3.55228 8 3 8Z"
      fill="currentColor"
      fillOpacity="0.565"
    />
    <path
      d="M13 2H12C11.4477 2 11 2.44772 11 3V13C11 13.5523 11.4477 14 12 14H13C13.5523 14 14 13.5523 14 13V3C14 2.44772 13.5523 2 13 2Z"
      fill="currentColor"
      fillOpacity="0.565"
    />
  </svg>
);

export const SubmittedByIcon = ({ className = '' }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-[#DCD8FE] ${className}`}>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.2105 4C10.6337 4 11.0126 4.18857 11.24 4.48L14 8L11.24 11.52C11.0126 11.8114 10.6337 12 10.2105 12L3.26316 11.9943C2.56842 11.9943 2 11.4857 2 10.8571V5.14286C2 4.51429 2.56842 4.00571 3.26316 4.00571L10.2105 4ZM11.125 9C11.6773 9 12.125 8.55228 12.125 8C12.125 7.44772 11.6773 7 11.125 7C10.5727 7 10.125 7.44772 10.125 8C10.125 8.55228 10.5727 9 11.125 9Z"
      fill="currentColor"
      fillOpacity="0.565"
    />
  </svg>
);

export const GenreIcon = ({ className = '' }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-[#DCD8FE] ${className}`}>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M2.10972 1.93688C2 2.20775 2 2.55017 2 3.235V12.765C2 13.4498 2 13.7922 2.10972 14.0631C2.26213 14.4394 2.56058 14.7379 2.93688 14.8903C3.20775 15 3.55017 15 4.235 15H11.765C12.4498 15 12.7922 15 13.0631 14.8903C13.4394 14.7379 13.7379 14.4394 13.8903 14.0631C14 13.7922 14 13.4498 14 12.765V7V3.235C14 2.55017 14 2.20775 13.8903 1.93688C13.7379 1.56058 13.4394 1.26213 13.0631 1.10972C12.7922 1 12.4498 1 11.765 1H9.63636H4.235C3.55017 1 3.20775 1 2.93688 1.10972C2.56058 1.26213 2.26213 1.56058 2.10972 1.93688ZM12 3.5C12 3.22386 11.7761 3 11.5 3H4.5C4.22386 3 4 3.22386 4 3.5V5.5C4 5.77614 4.22386 6 4.5 6H4.60961C4.83905 6 5.03904 5.84385 5.09468 5.62127L5.42425 4.30299C5.46877 4.12492 5.62876 4 5.81231 4H7.25V11C7.25 11.5523 6.80228 12 6.25 12H5.83333C5.3731 12 5 12.3731 5 12.8333C5 12.9254 5.07462 13 5.16667 13H10.8333C10.9254 13 11 12.9254 11 12.8333C11 12.3731 10.6269 12 10.1667 12H9.75C9.19772 12 8.75 11.5523 8.75 11V4H10.1877C10.3712 4 10.5312 4.12492 10.5757 4.30299L10.9053 5.62127C10.961 5.84385 11.161 6 11.3904 6H11.5C11.7761 6 12 5.77614 12 5.5V3.5Z"
      fill="currentColor"
      fillOpacity="0.565"
    />
  </svg>
);

export const LoglineIcon = ({ className = '' }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-[#DCD8FE] ${className}`}>
    <path
      d="M12.9548 3H10.0457C9.74445 3 9.50024 3.24421 9.50024 3.54545V6.45455C9.50024 6.75579 9.74445 7 10.0457 7H12.9548C13.256 7 13.5002 6.75579 13.5002 6.45455V3.54545C13.5002 3.24421 13.256 3 12.9548 3Z"
      fill="currentColor"
      fillOpacity="0.565"
    />
    <path
      d="M6.45455 3H3.54545C3.24421 3 3 3.24421 3 3.54545V6.45455C3 6.75579 3.24421 7 3.54545 7H6.45455C6.75579 7 7 6.75579 7 6.45455V3.54545C7 3.24421 6.75579 3 6.45455 3Z"
      fill="currentColor"
      fillOpacity="0.565"
    />
    <path
      d="M6.45455 9.50024H3.54545C3.24421 9.50024 3 9.74445 3 10.0457V12.9548C3 13.256 3.24421 13.5002 3.54545 13.5002H6.45455C6.75579 13.5002 7 13.256 7 12.9548V10.0457C7 9.74445 6.75579 9.50024 6.45455 9.50024Z"
      fill="currentColor"
      fillOpacity="0.565"
    />
    <path
      d="M12.9548 9.50024H10.0457C9.74445 9.50024 9.50024 9.74445 9.50024 10.0457V12.9548C9.50024 13.256 9.74445 13.5002 10.0457 13.5002H12.9548C13.256 13.5002 13.5002 13.256 13.5002 12.9548V10.0457C13.5002 9.74445 13.256 9.50024 12.9548 9.50024Z"
      fill="currentColor"
      fillOpacity="0.565"
    />
  </svg>
);

export const NotesIcon = ({ className = '' }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-[#DCD8FE] ${className}`}>
    <path
      opacity="0.87"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5 1C2.79086 1 1 2.79086 1 5V11C1 13.2091 2.79086 15 5 15H11C13.2091 15 15 13.2091 15 11V5C15 2.79086 13.2091 1 11 1H5ZM7.72114 4.29396C7.63221 3.98271 7.35362 3.76363 7.03017 3.75061C6.70672 3.73759 6.41142 3.93356 6.29775 4.23666L4.98025 7.75H3.5C3.08579 7.75 2.75 8.08579 2.75 8.5C2.75 8.91422 3.08579 9.25 3.5 9.25H5.5C5.81263 9.25 6.09247 9.05608 6.20225 8.76335L6.90367 6.89289L8.27886 11.706C8.36382 12.0034 8.62263 12.2182 8.93059 12.2468C9.23855 12.2754 9.5325 12.1121 9.67082 11.8354L10.9635 9.25H12.5C12.9142 9.25 13.25 8.91422 13.25 8.5C13.25 8.08579 12.9142 7.75 12.5 7.75H10.5C10.2159 7.75 9.95622 7.91051 9.82918 8.16459L9.19145 9.44005L7.72114 4.29396Z"
      fill="currentColor"
      fillOpacity="0.565"
    />
  </svg>
);

export const ResponseStatusIcon = ({ className = '' }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-[#DCD8FE] ${className}`}>
    <path
      d="M5 13.0001L4.99998 1.00018L1.40251 3.04575C1.15509 3.17511 1 3.4312 1 3.7104V14.2502C1 14.5204 1.14535 14.7697 1.38048 14.9028C1.61562 15.036 1.90419 15.0323 2.13588 14.8933L5 13.0001Z"
      fill="currentColor"
      fillOpacity="0.565"
    />
    <path
      d="M6 1.00018V13.0001L9.99998 15.0001V3.00209L6 1.00018Z"
      fill="currentColor"
      fillOpacity="0.565"
    />
    <path
      d="M14.6935 12.105L11 15.0001V3.00209L13.8641 1.10697C14.0958 0.967953 14.3844 0.964312 14.6195 1.09744C14.8547 1.23057 15 1.47989 15 1.75009V11.5002C15 11.7391 14.8862 11.9637 14.6935 12.105Z"
      fill="currentColor"
      fillOpacity="0.565"
    />
  </svg>
);

export const PriorityIcon = ({ className = '' }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={`text-[#DCD8FE] ${className}`}>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.111 1H4.89L4.683 1.005C2.631 1.111 1 2.781 1 4.826V11.174L1.005 11.377C1.113 13.396 2.81 15 4.89 15H5.15L5.255 14.993C5.43974 14.9693 5.60964 14.8794 5.7332 14.7401C5.85676 14.6007 5.92561 14.4213 5.927 14.235C5.92622 14.1336 5.90547 14.0334 5.86595 13.94C5.82642 13.8467 5.7689 13.762 5.69665 13.6909C5.62441 13.6197 5.53886 13.5635 5.44489 13.5255C5.35093 13.4874 5.25038 13.4682 5.149 13.469H4.889L4.73 13.464C3.516 13.384 2.557 12.389 2.557 11.174V4.826L2.562 4.669C2.644 3.475 3.655 2.531 4.89 2.531H11.112L11.272 2.536C12.486 2.616 13.452 3.611 13.452 4.826V4.93C13.479 5.11479 13.5719 5.28359 13.7136 5.40525C13.8553 5.52691 14.0362 5.59324 14.223 5.592C14.653 5.592 15.001 5.249 15.001 4.826L14.996 4.623C14.887 2.604 13.19 1 11.11 1H11.111ZM14.968 9.903C14.9944 9.85112 15.005 9.79258 14.9982 9.73475C14.9914 9.67691 14.9677 9.62237 14.93 9.578L12.905 7.116C12.8755 7.08117 12.839 7.05292 12.7979 7.03308C12.7568 7.01325 12.712 7.00227 12.6663 7.00085C12.6207 6.99944 12.5753 7.00762 12.533 7.02487C12.4908 7.04213 12.4526 7.06806 12.421 7.101L10.107 9.562C10.0544 9.61809 10.0251 9.69209 10.025 9.769C10.025 9.939 10.167 10.077 10.343 10.077H11.465C11.31 13.86 8.306 14.382 8.267 14.389C8.19372 14.3995 8.12657 14.4357 8.07763 14.4913C8.02869 14.5468 8.00116 14.618 8 14.692V14.717C8.013 14.877 8.152 15.001 8.318 15C8.372 15 13.623 14.942 13.836 10.077H14.681C14.7403 10.0774 14.7985 10.0614 14.8491 10.0306C14.8998 9.99992 14.941 9.95573 14.968 9.903Z"
      fill="currentColor"
      fillOpacity="0.565"
    />
  </svg>
);

export const ActiveIcon = ({ className = '' }) => (
  <svg
    className={`text-[lch(62.6%,1.35,272/1)] ${className}`}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="currentColor"
    role="img"
    focusable="false"
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M4.25 1A3.25 3.25 0 0 0 1 4.25v4.5A3.25 3.25 0 0 0 4.25 12h4.5A3.25 3.25 0 0 0 12 8.75v-4.5A3.25 3.25 0 0 0 8.75 1h-4.5ZM2.5 4.25c0-.966.784-1.75 1.75-1.75h4.5c.966 0 1.75.784 1.75 1.75v4.5a1.75 1.75 0 0 1-1.75 1.75h-4.5A1.75 1.75 0 0 1 2.5 8.75v-4.5Z"></path>
    <path d="M5.043 14.136C4.556 13.685 4.98 13 5.645 13c.244 0 .472.105.678.235.269.168.587.265.927.265h4.5c.477 0 .91-.19 1.225-.5H13v-.025c.31-.316.5-.748.5-1.225v-4.5c0-.34-.097-.658-.265-.927-.13-.206-.235-.434-.235-.678 0-.664.684-1.09 1.136-.602.536.58.864 1.355.864 2.207v4.5A3.25 3.25 0 0 1 11.75 15h-4.5a3.238 3.238 0 0 1-2.207-.864Z"></path>
  </svg>
);
